import {Component} from "./Component";
import {measureTextSizeFactory} from "../util/dom";
import {toPixels} from "../util/units";


export class InputSuffix extends Component {
    static name = "input-suffix";


    /**
     * @param {HTMLElement} el
     */
    constructor(el) {
        super(el);

        /**
         * @type {HTMLInputElement}
         */
        this.input = el.querySelector("input");

        /**
         * @type {HTMLElement}
         */
        this.suffix = el.querySelector(".input-suffix__suffix");

        this.measureText = measureTextSizeFactory(getComputedStyle(this.input));

        this.updateSuffix();

        this.addEventListener(this.input, "input", this.updateSuffix.bind(this));

    }

    updateSuffix() {
        const width = this.input.value.length ? this.measureText(this.input.value).width : 0;
        // const width = getTextWidth(input.value, fontStyle);
        this.suffix.style.left = toPixels(width);
    }

}
